export const OPEN_IN_NEW_TAB = '_blank';
/**
 * noopener: Navigate to the target resource without granting the new browsing context access (https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel/noopener)
 * noreferrer: Omit the Referer header and otherwise leak no referrer information (https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel/noreferrer)
 */
export const FEATURES = 'noopener,noreferrer';

export const openWindow = (url: string, target: string = OPEN_IN_NEW_TAB): void => {
  window.open(url, target, FEATURES);
  window.opener = null;
};
